<template>
    <v-dialog
      v-model="show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon @click="showNotifications()" v-bind="attrs" :disabled="notifications.length < 1">
            <v-badge
              color="red"
              :content="notifications.length"
              :value="notifications.length"
              overlap
              :small="!(notifications.length > 0)"
              v-on="on"
            >
              <v-icon
                v-bind:style="{
                  padding: notifications.length > 0 ? '18px' : '0px',
                  'border-radius': '50%',
                  'background-color': notifications.length > 0 ? 'black' : 'white',
                  color: notifications.length > 0 ? 'white' : 'black'
                }"
                >mdi-bell</v-icon
              >
            </v-badge>
          </v-btn>
      </template>
      <v-card>
        <v-toolbar
          light
          color="white"
        >
          <v-btn
            icon
            dark
            @click="show = false"
          >
            <v-icon color="black">mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title style="color:#000000">Notifications</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <v-list
          three-line
        >
          <template v-for="(item, index) in notifications">
            <v-divider :key="'Divider::'+index"></v-divider>
            <v-list-item @click="doAction(item)" :key="'notification'+index" :dark="item.viewed == true" :class="{viewed: item.viewed}" dense>   
                <v-list-item-avatar style="width:20px">
                    <v-img src="~/img/icons/wifirequest.svg"></v-img>
                </v-list-item-avatar>
                <v-list-item-content style="padding-top:0px;">
                <v-list-item-title style="color:#f4693a;font-size:16px">{{ item.title }}</v-list-item-title>
                <v-list-item-subtitle style="color:#000000;font-size:14px;margin-top:-20px">{{ item.body }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action style="align-self:center;margin-top:5px;">
                    <v-btn icon >
                        <v-icon color="grey darken-3">mdi-chevron-right</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
    </v-dialog>
</template>


<script>
import axios from "./../../plugins/axios";
import helper from "./../../utils/helper";
  export default {
    name: "Notifications",
    props: ["selectedLocation", "userData"],
    mounted: function() {
      console.log("REMOUNTED NOTIFICATIONS");
      if (this.selectedLocation && this.selectedLocation.nasid)
        this.getNotifications();
    },
    data: function () {
      return {
        show: false,
        notifications: [],
        sound: true,
        widgets: false,
      }
    },
    methods: {
      markNotificationsAsViewed: function() {
        axios.post("/wiom/MarkNotificationsAsViewed", {
          source: 1,
          recipientId: this.userData.userid,
          recipientSubid: this.selectedLocation.nasid,
          recipientToken: helper.getCookie("push-token")
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
      },
      showNotifications: function() {
        let that = this;
        this.show = true;
        setTimeout(function() {
          if (this.show == true)
            that.markNotificationsAsViewed();
        }, 2000);
      },
      getNotifications: function() {
        
        axios.post("/wiom/GetNotifications", {
          source: 1,
          recipientId: this.userData.userid,
          recipientSubid: this.selectedLocation.nasid,
          recipientToken: helper.getCookie("push-token")
        })
        .then((response) => {
          this.notifications = [];
          this.notifications = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
      },
      doAction: function(item) {
        switch(item.type) {
          case 100:
            if (item.recipientSubid && item.recipientSubid > 0)
              this.$router.push(`/manage/customers/${item.recipientSubid}`).then(() => {
                this.show = false;
              }).catch(() => {
                this.show = false;
                location.reload();
              });
              console.log(`GO TO /manage/customers/${item.recipientSubid}`);
            break;
        };
      }
    }
  }
</script>
<style scoped>
  .viewed {
    background-color: #f2f2f2;
  }
</style>